import browserInfo from './browser-utils';
import axios from 'axios';
import _get from 'lodash/get';

const featureFlagId = 'CALLME_NewGuestFlow';
const featureFlagApiConfig = {
  headers: { 'x-api-key': process.env.REACT_APP_FEATURE_FLAG_SERVICE_API_KEY }
};

async function getExtensionData(extension) {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/fetch/getAll/${extension}`);
  return response.data;
}

async function isNewGuestFlowEnabled(groupId) {
  if (!groupId) {
    throw new Error('Missing parameter: groupId');
  }
  const url = new URL(process.env.REACT_APP_FEATURE_FLAG_SERVICE_URL);
  url.searchParams.set('guest', 'true');
  url.searchParams.set('featureFlags', featureFlagId);
  url.searchParams.set('groupId', groupId);
  const response = await axios.get(url.href, featureFlagApiConfig);
  return !!_get(response, ['data', featureFlagId]);
}

async function redirectIfSupported(groupId, extension) {
  if (groupId && extension && browserInfo.isNewGuestFlowSupported && (await isNewGuestFlowEnabled(groupId))) {
    const guestFlowUrl = `https://${process.env.REACT_APP_NEW_GUEST_FLOW}/${extension}`;
    console.log(`Redirecting to new guest flow: ${guestFlowUrl}`);
    window.location = guestFlowUrl;
    return true;
  }
}

export default { redirectIfSupported, getExtensionData };
